// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const brokerMyInvestmentsActions = require('actions/brokerMyInvestments');

// @constants
const actionTypes = require('../raConstants/actionTypes');

const setPortfolioData = portfolioData => ({
    type: actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_DATA,
    payload: { data: portfolioData },
});

const readPortfolioFromGlobalPosition = portfolioId => (dispatch, getState) => {
    const immGlobalPosition = getState().raGlobalPosition;
    if (immGlobalPosition.get('hasRoboHired')) {
        const immPortFolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        dispatch(setPortfolioData(immPortFolio.toJSON()));
    }
};

const setPortfolioNameInProgress = () => ({
    type: actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_IN_PROGRESS,
});

const setPortfolioNameInSuccess = (portfolioName, namePosition) => ({
    type: actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_SUCCESS,
    payload: {
        portfolioName,
        namePosition,
    },
});

const setPortfolioNameFailure = error => ({
    type: actionTypes.RA_PORTFOLIO_DETAILS_SET_PORTFOLIO_NAME_FAILURE,
    payload: error,
});

const setHeaderTitleError = () => ({
    type: actionTypes.RA_PORTFOLIO_DETAILS_HEADER_TITLE_ERROR_ENABLED,
});

const updatePortfolioName = (portfolioId, portfolioName, namePosition) => (
    dispatch,
    getState,
) => {
    const query = {
        displayName: portfolioName,
    };
    const params = {
        portfolioId,
    };

    dispatch(setPortfolioNameInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('raUpdateAccount', params), {
        query,
    })
        .then(() => {
            dispatch(setPortfolioNameInSuccess(portfolioName, namePosition));
            brokerMyInvestmentsActions.outdateMyInvestments()(dispatch);
            brokerMyInvestmentsActions.fetchMyInvestments()(dispatch, getState);
        })
        .catch(error => {
            if (error.error) {
                dispatch(setPortfolioNameFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

const reset = () => ({
    type: actionTypes.RA_PORTFOLIO_DETAILS_RESET,
});

module.exports = {
    setHeaderTitleError,
    readPortfolioFromGlobalPosition,
    reset,
    updatePortfolioName,
};
